// extracted by mini-css-extract-plugin
export default {"Container":"_404_Container__hB9Fy","Text":"_404_Text__DVf7N","Title":"_404_Title__CLUv7","Subtitle":"_404_Subtitle__Wj6QG"};